export const promotions = {
  // cashiers promo
  cashiersTournamentSide: "Cashier's Tournament",
  cashiersTournament: 'Tournoi de caisse',
  cashiersCollectPoints:
    'Collectez des points au fur et à mesure que la GGR de vos joueurs grandit et participez au précieux tirage au sort!',
  cashiersMoreConditions: 'Plus de conditions ici',
  cashiersConditions: 'Conditions',
  cashiersRules: `Pour participer au tournoi, les joueurs inscrits sous la caisse doivent place de paris auprès de n'importe quel fournisseur sur le site.
\nPlus vos joueurs gagnent de GGR, plus vous obtiendrez de points.
\n1 TND en GGR (pari - gagné) = 0,01 point.
\nLa note du caissier est mise à jour tous les jours. La liste des caissiers gagnants sera établie en fonction de la GGR de leurs joueurs. Le tournoi se déroulera à partir de 10 Avril - 10 Mai.`,
  cashiersMyPoints: 'Mes points',
  cashiersUntilEnd: "Jusqu'à la fin du tournoi",
  cashiersRating: 'Cote de Caissier',
  cashiersId: 'Caissier ID',
  cashiersPoints: 'Points',
  cashiersTimer: {
    before: 'Temps restant avant le début du tournoi',
    after: 'Le tournoi est terminé',
    during: "Jusqu'à la fin du tournoi",
  },
  cashiersDays: 'Jours',
  cashiersHours: 'Heures',
  cashiersMinutes: 'Minutes',
  cashiersOrdinalNumbers: [
    '1<b>st</b>',
    '2<b>nd</b>',
    '3<b>rd</b>',
    '4<b>th</b>',
    '5<b>th</b>',
    '6<b>th</b>',
    '7<b>th</b>',
    '8<b>th</b>',
    '9<b>th</b>',
    '10<b>th</b>',
  ],
  cashiersTournamentText6: "À l'équilibre",
  cashiersTournamentText7: '4ème place',
  cashiersTournamentText8: '5ème-7ème place',
  cashiersTournamentText9: '8ème-10ème place',

  cashiersTournament2: {
    promoPageTitle: 'Tournoi spécial pour les caissiers!',
    mainText1: `Collectez des points au fur et à mesure que la GGR de vos joueurs grandit et participez au précieux tirage au sort!`,
    mainText2: 'Lire les conditions',
    tournamentIsNotStarted: 'Temps restant avant le début du tournoi',
    endOfTheTournament: `Jusqu'à la fin du tournoi`,
    tournamentIsEnded: 'Le tournoi est terminé',
    days: 'Jours',
    hours: 'Heures',
    minutes: 'Minutes',

    prizesText1: 'Gros',
    prizesText2: `Prix`,
    place: 'place',
    sideTitle: 'Tournoi de caisse',

    details: `Les détails de la promotion se trouvent dans le panneau d'administration`,

    endText: 'Participez et gagnez <br>avec X10<span style="color: #E9A722;">BET</span>!',

    conditions: {
      cond1: `Pour participer au tournoi, les joueurs inscrits sous la caisse doivent place de paris auprès de n'importe quel fournisseur sur le site.`,
      cond2: 'Plus vos joueurs gagnent de GGR, plus vous obtiendrez de points.',
      cond3: '1 TND en GGR (pari - gagné) = 0,01 point.',
      cond4: `La note du caissier est mise à jour tous les jours. La liste des caissiers gagnants sera établie en fonction de la GGR de leurs joueurs. Le tournoi se déroulera à partir de 26 Août - 26 Septembre.`,
    },

    cashier: 'Caissier',
    cashierId: 'Caissier ID',
    rating: 'Cote de',
    points: 'Mes points',
    prize: 'Prix',
    point: 'Points',
    top10: 'Top 10 des Caissiers',
    ratingIsEmpty: 'Le tableau est vide',

    resultText1:
      "Le Tournoi des Сaissiers s'est déroulé tout au long du mois de septembre et il est temps d'annoncer les résultats!",
    resultText2:
      "Félicitations aux gagnants et un grand merci à tous les agents qui ont participé et ont fait preuve d'une si grande implication.",
    resultText3: 'Les prix seront crédités sur les soldes des gagnants très prochainement.',
    resultText4: "Restez à l'écoute et ne manquez pas votre chance!",
    results: 'résultats',

    result13: 'Chaque gagnant recevra une notification dans le panneau d’administration avec des instructions supplémentaires sur la manière de recevoir les prix.',
    result14: "x10bet ne facture aucun frais pour la livraison des prix !",
  },

  promotionsDepositPromo: {
    title: 'Comment',
    description: 'obtenir le bonus?',

    rules: {
      title: `Rechargez votre solde <br /> en utilisant USDT`,
      description: `Recevez immédiatement +10% <br /> du montant de l'acompte`,
    },

    additionalInfo: {
      title: `Informations <br /> complémentaires`,
      description: `Le bonus est crédité sur chaque dépôt`,
      dates: `Dates de la promotion: du <br /> 2 Mars au 2 Avril`,
    },
  },

  superadminBonusSistem: {
    title: 'Ligue X10',
    currentStatus: 'Statut actuel',
    amountDepositsLast30Days: 'Montant des dépôts des 30 derniers jours',
    progressToNextLevel: 'Progression vers le niveau suivant',
    nextLevel: 'Niveau suivant',
    reward: 'Récompense',
    levelUpBonus: 'Bonus de montée de niveau',
    onEveryDeposit: 'sur chaque dépôt',
    perDeposit: 'par dépôt',
    oneTimeReward: 'récompense unique',
    usdtUntilNextLevel: 'USDT jusqu’au niveau suivant',

    grades: {
      bronze: 'Bronze',
      silver: 'Argent',
      gold: 'Or',
      platinum: 'Platine',
      diamond: 'Diamant',
      brilliant: 'Brilliant Partner',
    },
  },
};
